var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ta_left"},[_vm._v("新浪理财大学重磅推出王者《碎片化创新语音课》干货提炼，交易日实盘语音精确实时指导，"),_c('a',{staticClass:"blue r-eid-adVipAudioTxt",attrs:{"href":_vm.urlVipAudio}},[_vm._v("点击链接免费收听")])])}
var staticRenderFns = []

export { render, staticRenderFns }